import { render, staticRenderFns } from "./KegiatanAdd.vue?vue&type=template&id=7fb016eb&scoped=true"
import script from "./KegiatanAdd.vue?vue&type=script&lang=js"
export * from "./KegiatanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb016eb",
  null
  
)

export default component.exports